import { createSelector } from '@ngrx/store';
import { selectSearchBoxParams } from '../router/router.selector';
import { selectDestination, selectHotels } from '../../modules/results/store/results.selector';
import { selectLoading, selectError } from '@results/store/results.selector';

export const selectInitialSearchData = createSelector(
  selectSearchBoxParams,
  selectDestination,
  selectLoading,
  selectError,
  selectHotels,
  (params, destination, loading, error, hotels) => {
    if (!params) {
      return undefined;
    }

    if (loading) {
      return undefined;
    }

    if (error || !!hotels) {
      return {
        ...params,
        origin: {
          id: params.entity.id,
          label: params.entity.name,
        },
      };
    }

    if (!destination) {
      return undefined;
    }

    const origin: any = {
      id: params.entity.id,
      label: params.entity.name,
    };

    if (destination?.country?.country_code) {
      origin.country_code = destination.country.country_code;
    }

    return {
      ...params,
      origin,
    };
  },
);
